import React from 'react';
import PropTypes from 'prop-types';
import { OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import AdvancedSearchUtility from '../../utility/AdvancedSearchUtility';
import createFacet from '../../classes/facets/FacetFactory';
import FacetType from '../../utility/types/facetType';

function FilterDisplay({
  facetId, filters,
}) {
  const facetUtility = createFacet(facetId);
  const filtersByOperator = AdvancedSearchUtility.sortFiltersByOperatorType(filters);
  const displayNameFacets = [FacetType.ALERT_NAME,
    FacetType.CHANNEL_TYPE, FacetType.ALERT_TAGS, FacetType.DEVICE_TAGS, FacetType.THRESHOLD];
  return (
    <>
      {
        displayNameFacets.includes(facetId)
          ? (
            <>
              <b>
                {facetUtility.getDisplayName()}
              </b>
              {' '}
              {facetUtility.getDescription()}
            </>
          )
          : facetUtility.getDescription()
      }
      <ul>
        {Object.entries(filtersByOperator).map(([operatorType, currFilters]) => (
          <li className="ml-3">
            {
            facetUtility.getOperatorDescription(operatorType)
            }
            {' '}
            {`${Array.from(new Set(currFilters.map((item) => `${facetUtility
              .getDisplayValue1(item.value1,
                operatorType)}`))).join(operatorType === OperatorTypes.CONTAINS_ALL
              ? ' and '
              : ' or ')}

              ${currFilters[0].value2 && facetUtility.getDisplayValue2(currFilters[0].value2, operatorType).length > 0
              ? `- ${facetUtility.getDisplayValue2(currFilters[0].value2, operatorType)}`
              : ''}`}
          </li>
        ))}
      </ul>
    </>
  );
}

FilterDisplay.propTypes = {
  facetId: PropTypes.number.isRequired,
  filters: PropTypes.number.isRequired,
};

export default FilterDisplay;
